// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from 'firebase/auth'
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDZZ-iaAOhkYHVQuCSxSzJaB_rLrCxyol4",
  authDomain: "cars-project-83013.firebaseapp.com",
  projectId: "cars-project-83013",
  storageBucket: "cars-project-83013.appspot.com",
  messagingSenderId: "117812728832",
  appId: "1:117812728832:web:d15e2cc50db4764333f4e5",
  measurementId: "G-ZTNZF5MTV8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth =getAuth();